/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import useState from "react-usestateref";
import axios from "axios";
import { toast } from "react-toastify";
import { UsersTable } from "../../components/Tables";

export default ({ load, handleEditData }) => {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading, loadingRef] = useState(false);

  React.useEffect(() => {
    getUsers();
  }, [page, load]);

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.accessToken}`,
    },
  };
  const getUsers = () => {
    setLoading(true);
    axios
      .get(`${process.env.REACT_APP_BACKEND_API}/v1/users?page=${page}`, config)
      .then((res) => {
        setData(res.data.results);
        setLoading(false);
        toast.success("Users");
      })
      .catch((err) => {
        setData([]);
        setLoading(false);
        toast.error("Unexpected error");
      });
  };

  return (
    <>
      <UsersTable
        data={data}
        loading={loadingRef.current}
        setPage={setPage}
        handleEditData={handleEditData}
      />
    </>
  );
};
